import Home from 'components/view/Home'
import {tabNames, TabType} from 'router/settings'
import defaultTotalsState from 'redux/totals/state'
import {GridStateParamsType} from 'commonTypes'
import {StateDeclaration} from '@uirouter/core'

const homeState = {
  name: 'home',
  url: '/',
  component: Home,
  resolve: [{
    token: 'title',
    resolveFn: () => tabNames[TabType.home],
  }],
  params: {
    filters: defaultTotalsState.gridSession.filters,
  } as GridStateParamsType,
} as StateDeclaration

export default homeState
